import styled from '@emotion/styled';
import { ErrorOutlineOutlined as ErrorIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';

const ErrorStateWrapper = styled('div')(({ theme }) => ({
  padding: 12,
  width: 400,
  maxWidth: '100%',
  height: 400,
  maxHeight: '100%',
  backgroundColor: `rgba(0, 0, 0, ${theme.isDark ? '0.3' : '0.05'})`,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  '.MuiSvgIcon-root': {
    marginBottom: 12,
    width: 64,
    height: 64,
    color: theme.palette.error.main,
  },
  h3: {
    textAlign: 'center',
  },
}));

const ImageErrorState = () => (
  <ErrorStateWrapper>
    <ErrorIcon />
    <h3>
      <FormattedMessage id="portfolio.challenge.files.uploaded_image.error_state.messages.no_longer_available" />
    </h3>
  </ErrorStateWrapper>
);

export default ImageErrorState;
